import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { loadPricing } from './lib/pricing';

// Saved plan prices (Admin → Payments → Prices); public cards never show prices
if (!window.location.pathname.startsWith('/c/')) loadPricing();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
